module.exports = __webpack_public_path__ + "img/cover.73773e93.png";